import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { UserType } from '@src/types/users';
import queryString from 'query-string';
import { DuplicateUsers } from '@features/admin/users/DuplicateUsers.tsx';
import { UsersDashboard } from '@features/admin/users/UsersDashboard.tsx';

export const UsersPage = () => {
  const location = useLocation();

  const route = useMemo(() => {
    const parseData = queryString.parse(location.search);

    if (!parseData) {
      return null;
    }

    return parseData as unknown as { type: UserType };
  }, [location.search]);

  if (route?.type === UserType.DuplicateUsers) {
    return <DuplicateUsers />;
  }

  return <UsersDashboard />;
};
